module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/12-2c1d21762384f8dfad9cd5940a790f63.png";